export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID;
